import AccountNSites from "./pages/AccountNSites"
import AddOns from "./pages/AddOns"
import ChargersAndMaterials from "./pages/ChargersAndMaterials"
import Infra from "./pages/Infra"
import LandDeal from "./pages/LandDeal"
import PaymentDetails from "./pages/PaymentDetails"
import PocDetails from "./pages/PocDetails"
import ProjectBasicDetailsWrapper from "./pages/ProjectBasicDetails"
import ProjectDealDetails from "./pages/ProjectDealDetails"
import SaaS from "./pages/Saas"
import { EProjectFormPages } from "./EProjectFormPages"

export { EProjectFormPages }

export const PROJECT_FORM_PAGES_TO_FORM_STEPS: Record<EProjectFormPages, React.ComponentType<any>> = {
    [EProjectFormPages.DEAL_TYPE_TEMPLATE]: ProjectDealDetails,
    [EProjectFormPages.ACCOUNT_N_LOCATION]: AccountNSites,
    [EProjectFormPages.PROJECT_DETAILS]: ProjectBasicDetailsWrapper,
    [EProjectFormPages.MATERIAL_DETAILS]: ChargersAndMaterials,
    [EProjectFormPages.INFRA_DETAILS]: Infra,
    [EProjectFormPages.SAAS_DETAILS]: SaaS,
    [EProjectFormPages.LAND_DETAILS]: LandDeal,
    [EProjectFormPages.ADD_ONS]: AddOns,
    [EProjectFormPages.PAYMENT_DETAILS]: PaymentDetails,
    [EProjectFormPages.ON_GROUND_POC]: PocDetails,
}
